module.exports = __webpack_public_path__ + "img/check_outline_green.5fedd7e7.svg";